

//******************  ******************//
export const DateTimeShapeValues = [
    { key: '1', value: 'hour_minute', type: 'time', periodTypes: ['hour', 'minute'] },
    { key: '2', value: 'month_day', type: 'date', periodTypes: ['month', 'week', 'day'] },
    { key: '3', value: 'year', type: 'date', periodTypes: ['year'] },
    { key: '4', value: 'year_month', type: 'date', periodTypes: ['year', 'month'] },
    { key: '5', value: 'year_month_day', type: 'date', periodTypes: ['year', 'month', 'week', 'day'] },
    { key: '6', value: 'day_hour_minute', type: 'date_time', periodTypes: ['day'] },
    { key: '7', value: 'year_month_day_hour_minute', type: 'date_time', periodTypes: ['year', 'month', 'week', 'day', 'hour', 'minute'] }
] as const
